// Traduções para formulários - Português (Brasil)
export const formsPt = {
  validation: {
    required: 'Este campo é obrigatório',
    invalidEmail: 'E-mail inválido',
    invalidPhone: 'Número de telefone inválido',
    minLength: 'Mínimo de {min} caracteres',
    maxLength: 'Máximo de {max} caracteres',
  },

  fields: {
    name: 'Nome',
    fullName: 'Nome completo',
    email: 'E-mail',
    phone: 'Telefone',
    message: 'Mensagem',
    subject: 'Assunto',
    company: 'Empresa',
    address: 'Endereço',
  },

  actions: {
    submit: 'Enviar',
    reset: 'Redefinir',
    clear: 'Limpar',
    save: 'Salvar',
    cancel: 'Cancelar',
  },

  messages: {
    success: 'Formulário enviado com sucesso',
    error: 'Erro ao enviar o formulário',
    processing: 'Processando...',
  },
};
